import _classCallCheck from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

import { __awaiter } from "tslib";
import { makeRequest } from '@finam/txservices-core/request';
import { cancelable, pipeCancelablePromise } from '@finam/txservices-core/promise';
import { AuthRequest, TempLoginRequest, GetOneTimeTokenRequest, RenewRequest, AutologinRequest, ExchangeOneTimeTokenRequest, TokenScope, AuthProvidersRequest, LogoutDeviceRequest, LoggedDevicesRequest, TxAuthApiClient } from './proto';
import DeviceBuilder from './DeviceBuilder';
import TokenProvider from './TokenProvider';
import logger, { getDateString } from './logger';
import { parseToken } from './utils';

var AuthService = /*#__PURE__*/function () {
  function AuthService(hosts, _ref) {
    var _this = this;

    var appName = _ref.appName,
        appVersion = _ref.appVersion,
        widgetVersion = _ref.widgetVersion,
        getLocalId = _ref.getLocalId,
        setLocalId = _ref.setLocalId,
        onRenew = _ref.onRenew,
        onLogout = _ref.onLogout,
        onTokenRenewTimeout = _ref.onTokenRenewTimeout,
        onNotConfirmed = _ref.onNotConfirmed,
        tokenScope = _ref.tokenScope,
        renewMethodType = _ref.renewMethodType,
        getTokenReceiveTime = _ref.getTokenReceiveTime,
        setTokenReceiveTime = _ref.setTokenReceiveTime;

    _classCallCheck(this, AuthService);

    this.handleTokenRenewFailed = function (error) {
      if (!error || error.code) {
        _this.logout();
      }
    };

    this.getDevice = function () {
      if (!_this.device) {
        _this.device = _this.deviceBuilder.build();
      }

      return _this.device;
    };

    this.logout = function () {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                logger.log("".concat(getDateString(), " logging out"));
                this.stopRenew();

                if (!(this.onLogout !== undefined)) {
                  _context.next = 5;
                  break;
                }

                _context.next = 5;
                return this.onLogout();

              case 5:
                this.tokenProvider.removeToken();

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    };

    if (hosts.length === 0) {
      throw new TypeError('Empty hosts');
    }

    this.deviceBuilder = new DeviceBuilder(appName, appVersion, widgetVersion, getLocalId, setLocalId);
    this.tokenScope = tokenScope && AuthService.buildTokenScope(tokenScope);
    this.tokenProvider = TokenProvider.build(this.getDevice, hosts, renewMethodType, onRenew, this.handleTokenRenewFailed, onTokenRenewTimeout, onNotConfirmed, this.tokenScope, setTokenReceiveTime);
    this.onLogout = onLogout;
    this.getTokenReceiveTime = getTokenReceiveTime;
    this.setTokenReceiveTime = setTokenReceiveTime;
    this.request = makeRequest({
      hosts: hosts
    });
    this.requestAuthorized = makeRequest({
      hosts: hosts,
      tokenProvider: this.tokenProvider
    });
  }

  _createClass(AuthService, [{
    key: "getAuthProviders",
    value: function getAuthProviders() {
      var body = AuthProvidersRequest.create();
      var promise = this.request.unary({
        log: 'AuthService:providers',
        handler: function handler(transport, logRequest) {
          logRequest(body);
          return new TxAuthApiClient(transport).providers(body);
        }
      });
      return pipeCancelablePromise(promise, function (res) {
        return res.providers;
      });
    }
  }, {
    key: "getProviders",
    value: function getProviders() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getAuthProviders();

              case 2:
                res = _context2.sent;
                return _context2.abrupt("return", res.map(function (item) {
                  return item.name;
                }));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "authorize",
    value: function authorize(_ref2) {
      var provider = _ref2.provider,
          login = _ref2.login,
          password = _ref2.password,
          tokenTotalExpiration = _ref2.tokenTotalExpiration;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var body, res, receiveTime;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                logger.log("".concat(getDateString(), " authorize with login _").concat(login, "_ on provider *").concat(provider, "*"));
                body = AuthRequest.create({
                  provider: provider,
                  login: login,
                  password: password,
                  tokenScope: this.tokenScope,
                  device: this.getDevice(),
                  tokenTotalExpiration: tokenTotalExpiration
                });
                _context3.next = 4;
                return this.request.unary({
                  log: 'AuthService:authorize',
                  handler: function handler(transport, logRequest) {
                    logRequest(body);
                    return new TxAuthApiClient(transport).auth(body);
                  }
                });

              case 4:
                res = _context3.sent;
                receiveTime = Date.now();

                if (this.setTokenReceiveTime) {
                  this.setTokenReceiveTime(receiveTime);
                }

                _context3.next = 9;
                return this.tokenProvider.setToken(res.token, receiveTime);

              case 9:
                logger.log("".concat(getDateString(), " authorize successful!"));
                return _context3.abrupt("return", this.tokenProvider.buildResponse());

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "exchangeOneTimeToken",
    value: function exchangeOneTimeToken(ott, provider) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var body, res, parsedToken, receiveTime, renewRequest, renewResponse, _receiveTime;

        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                logger.log("".concat(getDateString(), " authorize with one time token _").concat(ott));
                body = ExchangeOneTimeTokenRequest.create({
                  token: ott,
                  device: this.getDevice(),
                  provider: provider
                });
                _context4.next = 4;
                return this.request.unary({
                  log: 'AuthService:exchangeOneTimeToken',
                  handler: function handler(transport, logRequest) {
                    logRequest(body);
                    return new TxAuthApiClient(transport).exchangeOneTimeToken(body);
                  }
                });

              case 4:
                res = _context4.sent;
                logger.log("".concat(getDateString(), " exchange ott successful!"));
                parsedToken = parseToken(res.token); // For 2fa and OAuth2 prevent Renew call

                if (!(parsedToken.tfa || parsedToken.provider.startsWith('OAUTH2'))) {
                  _context4.next = 15;
                  break;
                }

                receiveTime = Date.now();

                if (this.setTokenReceiveTime) {
                  this.setTokenReceiveTime(receiveTime);
                }

                this.stopRenew();
                _context4.next = 13;
                return this.tokenProvider.setToken(res.token, receiveTime);

              case 13:
                _context4.next = 25;
                break;

              case 15:
                // Renew received token to set full scope
                renewRequest = RenewRequest.create({
                  device: this.getDevice(),
                  token: res.token,
                  tokenScope: this.tokenScope || TokenScope.create()
                });
                _context4.next = 18;
                return this.request.unary({
                  log: 'AuthService:renew',
                  handler: function handler(transport, logRequest) {
                    logRequest(renewRequest);
                    return new TxAuthApiClient(transport).renew(renewRequest);
                  }
                });

              case 18:
                renewResponse = _context4.sent;
                _receiveTime = Date.now();

                if (this.setTokenReceiveTime) {
                  this.setTokenReceiveTime(_receiveTime);
                }

                this.stopRenew();
                _context4.next = 24;
                return this.tokenProvider.setToken(renewResponse.token, _receiveTime);

              case 24:
                logger.log("".concat(getDateString(), " exchanged token renew successful!"));

              case 25:
                return _context4.abrupt("return", this.tokenProvider.buildResponse());

              case 26:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "authorizeWithToken",
    value: function authorizeWithToken(token, receiveTime) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                logger.log("".concat(getDateString(), " authorize with _").concat(token, "_"));
                this.getDevice();
                _context5.next = 5;
                return this.tokenProvider.setToken(token, receiveTime || this.getTokenReceiveTime && this.getTokenReceiveTime());

              case 5:
                if (!(this.tokenProvider.getRenewMethodType() === 'unary')) {
                  _context5.next = 8;
                  break;
                }

                _context5.next = 8;
                return this.tokenProvider.renew();

              case 8:
                return _context5.abrupt("return", this.tokenProvider.buildResponse());

              case 11:
                _context5.prev = 11;
                _context5.t0 = _context5["catch"](0);
                logger.error('renew failed, token discarded', _context5.t0);
                throw _context5.t0;

              case 15:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 11]]);
      }));
    }
  }, {
    key: "confirmAuthorize",
    value: function confirmAuthorize(code) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var body, res, receiveTime;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                body = RenewRequest.create({
                  token: this.tokenProvider.getToken(),
                  device: this.getDevice(),
                  code: code,
                  tokenScope: this.tokenScope
                });
                _context6.next = 3;
                return this.request.unary({
                  log: 'AuthService:renew',
                  retry: {
                    maxAttempts: 2
                  },
                  handler: function handler(transport, logRequest) {
                    logRequest(body);
                    return new TxAuthApiClient(transport).renew(body);
                  }
                });

              case 3:
                res = _context6.sent;
                receiveTime = Date.now();

                if (this.setTokenReceiveTime) {
                  this.setTokenReceiveTime(receiveTime);
                }

                _context6.next = 8;
                return this.tokenProvider.setToken(res.token, receiveTime);

              case 8:
                logger.log("".concat(getDateString(), " authorization confirmation successful!"));
                return _context6.abrupt("return", this.tokenProvider.buildResponse());

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "oneTimeToken",
    value: function oneTimeToken(provider, tokenScope) {
      var _a;

      var body = GetOneTimeTokenRequest.create({
        token: this.tokenProvider.getToken(),
        tokenScope: ((_a = this.tokenScope) === null || _a === void 0 ? void 0 : _a.restricted) ? this.tokenScope : tokenScope,
        provider: provider
      });
      var promise = this.request.unary({
        log: 'AuthService:oneTimeToken',
        handler: function handler(transport, logRequest) {
          logRequest(body);
          return new TxAuthApiClient(transport).oneTimeToken(body);
        }
      });
      logger.log("".concat(getDateString(), " 'one-time token received successfully!"));
      return pipeCancelablePromise(promise, function (res) {
        return {
          oneTimeToken: res.token
        };
      });
    }
  }, {
    key: "tempLogin",
    value: function tempLogin(recordId) {
      var body = TempLoginRequest.create({
        recordId: typeof recordId === 'number' ? recordId.toString() : recordId,
        adminDevice: this.getDevice()
      });
      var promise = this.request.unary({
        log: 'AuthService:tempLogin',
        handler: function handler(transport, logRequest) {
          logRequest(body);
          return new TxAuthApiClient(transport).tempLogin(body);
        }
      });
      return pipeCancelablePromise(promise, function (res) {
        return {
          status: res.status,
          login: res.tempLogin,
          password: res.tempPassword
        };
      });
    }
  }, {
    key: "getAutoLoginUrl",
    value: function getAutoLoginUrl(route) {
      var body = AutologinRequest.create({
        route: route
      });
      var promise = this.requestAuthorized.unary({
        log: 'AuthService:getAutologinUrl',
        handler: function handler(transport, logRequest) {
          logRequest(body);
          return new TxAuthApiClient(transport).getAutologinUrl(body);
        }
      });
      return pipeCancelablePromise(promise, function (res) {
        return res.url;
      });
    }
  }, {
    key: "getLoggedDevices",
    value: function getLoggedDevices() {
      var verifiedOnly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var body = LoggedDevicesRequest.create({
        verifiedOnly: verifiedOnly
      });
      var stream = this.requestAuthorized.stream({
        log: 'AuthService:getLoggedDevices',
        handler: function handler(transport, logRequest) {
          logRequest(body);
          return new TxAuthApiClient(transport).getLoggedDevices(body);
        }
      });
      var subscription;
      return cancelable(new Promise(function (resolve, reject) {
        var result = [];
        subscription = stream.subscribe(function (message) {
          result = result.concat(message.devices);
        }, function (err) {
          return reject(err);
        }, function () {
          return resolve(result);
        });
      }), function () {
        return subscription === null || subscription === void 0 ? void 0 : subscription.unsubscribe();
      });
    }
  }, {
    key: "logoutDevice",
    value: function logoutDevice(keyId) {
      var body = LogoutDeviceRequest.create({
        keyId: keyId
      });
      return this.requestAuthorized.unary({
        log: 'AuthService:logoutDevice',
        handler: function handler(transport, logRequest) {
          logRequest(body);
          return new TxAuthApiClient(transport).logoutDevice(body);
        }
      });
    }
  }, {
    key: "stopRenew",
    value: function stopRenew() {
      this.tokenProvider.stopRenew();
    }
  }, {
    key: "resumeRenew",
    value: function resumeRenew() {
      this.tokenProvider.resumeRenew();
    }
  }, {
    key: "forceRenew",
    value: function forceRenew() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.tokenProvider.forceRenew();

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: "isLoggedIn",
    value: function isLoggedIn() {
      return Boolean(this.tokenProvider.getToken());
    }
  }, {
    key: "getTokenProvider",
    value: function getTokenProvider() {
      return this.tokenProvider;
    }
  }, {
    key: "setTokenScope",
    value: function setTokenScope(tokenScope) {
      var newTokenScope = tokenScope && AuthService.buildTokenScope(tokenScope);
      this.tokenScope = newTokenScope;
      this.tokenProvider.setTokenScope(newTokenScope);
    }
  }], [{
    key: "buildTokenScope",
    value: function buildTokenScope(tokenScope) {
      return TokenScope.create({
        content: (tokenScope.content instanceof Array ? tokenScope.content.reduce(function (prev, current) {
          return prev + current;
        }, 0) : tokenScope.content).toString(),
        readonly: tokenScope.readonly,
        restricted: tokenScope.restricted
      });
    }
  }]);

  return AuthService;
}();

export { AuthService as default };